import { IGetFuncionarioFiliaisUseCase } from "../../../presentation/useCases/read/get_funcionario_filiais_use_case";
import { FuncionarioFilialDropDown } from "../../models/funcionario_filial_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFuncionarioFiliaisUseCase
 */

export class GetFuncionarioFiliaisUseCase implements IGetFuncionarioFiliaisUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getFuncionarioFiliaisDropDown(): Promise<FuncionarioFilialDropDown[]> {
    return await this.repository.getFuncionarioFiliaisDropDown();
  }
}
